import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment';
import globals from '../../globals/communityGlobals';
import { recurrenceTypes } from '../../settings/constants';
import { cancelNonPatientActivity } from '../../actions/entities';

const locale = globals.getAreas(['nonPatientActivities', 'error', 'selectableListsValues', 'userActions']);

export const eventHandlers = (state, setState) => {
  const dispatch = useDispatch();

  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false }));
  };

  const onFiltersChange = model =>
    setState({
      ...state,
      selectedOrgUnits: model.selectedOrgUnits,
      selectedClinicians: model.selectedClinicians,
      dateFrom: model.dateFrom || null,
      dateTo: model.dateTo || null,
      currentPage: 1,
    });

  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
    }));

  const handleCreate = () => {
    dispatch(push('/NonPatientActivities/Create'));
  };

  const handleEdit = (id, recurrence) => {
    if (recurrence === recurrenceTypes.MONTHLY) {
      setState({ ...state, showEditNpaConfirmation: true });
    } else {
      dispatch(push(`/NonPatientActivities/Edit/${id}`));
    }
  };

  const handleDeleteNpaConfirm = async () => {
    setState({ ...state, showDeleteNpaConfirmation: !state.showDeleteNpaConfirmation });
    await dispatch(
      cancelNonPatientActivity({ NonPatientActivityId: state.currentItemId, shouldCreateDeleteEvent: true }),
    );
    setState({
      ...state,
      forceReload: !state.forceReload,
      showDeleteNpaConfirmation: false,
      currentItemId: 0,
    });
  };

  const confirmDelete = id => {
    setState({
      ...state,
      showDeleteNpaConfirmation: true,
      currentItemId: id,
    });
  };

  const handleDeleteNpaCancel = () => {
    setState({ ...state, showDeleteNpaConfirmation: false, currentItemId: 0 });
  };

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    dateFormats: globals.dateFormats.shortWithLongTime,
    moment,
    updateTableProps,
    updateTableSort,
    onClose,
    onFiltersChange,
    handleSidePanel: handleCreate,
    handleEdit,
    confirmDelete,
    handleDeleteNpaCancel,
    handleDeleteNpaConfirm,
    refreshTable,
  };
};
